import { OnboardingButton } from 'components/onboarding/components/DefaultButton';
import { useTranslation } from 'hooks/useTranslation';
import React, { Fragment, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import getFirstNode from 'utils/getFirstNode';
import { getRegion } from 'utils/Region';
import Logger from 'services/logger';

export const AUTH_TRANSLATION_KEYS = {
  TITLE: {
    key: 'Onboarding2_ConfirmacionB_Texto_Titulo_ConfirmacionCorrecta',
  },
  CONFIRM_1: {
    key: 'Onboarding2_ConfirmacionB_Texto_Parrafo1_Parte1',
  },
  CONFIRM_2: {
    key: 'Onboarding2_ConfirmacionB_Texto_Parrafo1_Parte2',
  },
  DEEPLINK_TXT: {
    key: 'Onboarding2_Boton_Texto_AbrirAplicacion',
  },
  CLOSE: {
    key: 'Onboarding2_Boton_Texto_CerrarSesion',
  },
};

export const AuthConfirmation = ({ isMobile, userhash }) => {
  const navigate = useNavigate();
  const { translationMapper } = useTranslation();
  const {
    Onboarding2_ConfirmacionB_Icono_ConfirmacionCorrecta = '',
  } = useSelector(state => state.asset);

  const translatedTexts = useMemo(
    () => translationMapper(AUTH_TRANSLATION_KEYS),
    [],
  );

  const handleDeeplink = () => {
    try {
      const encodedHash = encodeURIComponent(userhash);
      const deeplink = `dlaapk://www.clarovideo.com/${getRegion()}/onboarding/complete#user_hash=${encodedHash}`;

      // Abrir el deeplink
      window.location.href = deeplink;
    } catch (error) {
      Logger.error('DEEPLINK failed', { error: error?.message, stack: error?.stack });
    }
  };

  return (
    <Fragment>
      <img
        className="AppAuthConfirmModal__Content__Icon"
        src={Onboarding2_ConfirmacionB_Icono_ConfirmacionCorrecta}
        alt="auth-success"
      />
      <h2 className={'AppAuthConfirmModal__Content__Title'}>
        {translatedTexts.TITLE}
      </h2>
      <p className="AppAuthConfirmModal__Content__Block1">
        {translatedTexts.CONFIRM_1}
        <br />
        {translatedTexts.CONFIRM_2}
      </p>
      <div
        className="AppAuthConfirmModal__Content__AppButton"
        style={{ marginTop: 72 }}
      >
        <OnboardingButton
          textContent={translatedTexts.DEEPLINK_TXT}
          size="large"
          variant="secondary"
          className="AppAuthConfirmModal__Content__AppButton__Download"
          onClick={handleDeeplink}
        />
      </div>
      <button
        className={'AppAuthConfirmModal__Content__Button'}
        onClick={() => navigate(`/${getRegion()}/landing`, { replace: true })}
      >
        {translatedTexts.CLOSE}
      </button>
    </Fragment>
  );
};
